import { Typography, Button, Grid2 as Grid } from "@mui/material";
import React from "react";
import { environment } from "../../config/environment";

export function ConnectionTip() {
  return (
    <Grid container={true} direction="column" height="100%" alignItems="center" justifyContent="center" spacing={1}>
      <Typography>Complete your ledger connection</Typography>
      <Button variant="outlined" href={`${environment.webAppUrl}/connections`} target="_blank">
        Connect
      </Button>
    </Grid>
  );
}
